module.exports = __webpack_public_path__ + "img/CLIC-Red-Logo .15536666.png";